import { URL_API } from "@/config";
import { tokenDecrypted } from "@/utils/decryptToken";
import { url } from "@/utils/urlParam";
import axios from "axios";

const baseUrl = "users-and-roles";

export async function GetUsers({ companyId, page, limit, selectedUserFilter }) {
  try {
    const params = new URLSearchParams(url.search);
    params.append("page", page || 1);
    params.append("limit", limit || 5);
    params.append("compid", companyId);
    params.append("filter", selectedUserFilter);
    const { data } = await axios.get(
      `${URL_API}/${baseUrl}/users?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${tokenDecrypted()}`,
        },
      }
    );
    return {
      success: true,
      message: "",
      data: data.data,
      meta: data.meta,
      code: 200,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response.statusText,
      data: [],
      data: {},
      code: error.response.status,
    };
  }
}

export async function SwitchUserStatus({ userId, status }) {
  try {
    const params = new URLSearchParams(url.search);
    params.append("id", userId);
    params.append("s", status);
    await axios.get(`${URL_API}/${baseUrl}/sUS?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${tokenDecrypted()}`,
      },
    });
    return {
      success: true,
      message: "",
      code: 200,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response.statusText,
      code: error.response.status,
    };
  }
}

export const AddUsersAPI = async (payload, query) => {
  try {
    const response = await axios.post(`${URL_API}/uar${query}`, payload, {
      headers: {
        Authorization: `Bearer ${tokenDecrypted()}`,
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};
export const EditUser = async (id, payload) => {
  try {
    const response = await axios.put(`${URL_API}/uar/${id}`, payload, {
      headers: {
        Authorization: `Bearer ${tokenDecrypted()}`,
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};
export const DeleteUser = async (id) => {
  try {
    const response = await axios.delete(`${URL_API}/uar/${id}`, {
      headers: {
        Authorization: `Bearer ${tokenDecrypted()}`,
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export async function GetRoles({ companyId, page, limit }) {
  try {
    const params = new URLSearchParams(url.search);
    // params.append("page", page || 1);
    // params.append("limit", limit || 5);
    params.append("compid", companyId);
    const { data } = await axios.get(
      `${URL_API}/${baseUrl}/roles?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${tokenDecrypted()}`,
        },
      }
    );
    return {
      success: true,
      message: "",
      data: data.data,
      // meta: data.meta,
      code: 200,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response.statusText,
      data: [],
      // data: {},
      code: error.response.status,
    };
  }
}
